import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { loginTwoFactorAuthEmailPost } from '@src/api'
import {
  AuthenticationResponse,
  DefaultApiLoginTwoFactorAuthEmailPostRequest,
} from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

import { LoginWithEmailMfaError } from './type'

export function useLoginTwoFactorAuthEmail() {
  const { axiosInstance } = useAxios({ apiType: 'IAM', shouldSkipLogout: true })

  return useMutation<
    AxiosResponse<AuthenticationResponse>,
    AxiosResponse<LoginWithEmailMfaError>,
    DefaultApiLoginTwoFactorAuthEmailPostRequest
  >({
    mutationFn: (params: DefaultApiLoginTwoFactorAuthEmailPostRequest) =>
      loginTwoFactorAuthEmailPost(axiosInstance, params),
  })
}
